import { render } from "./CautionStream.vue?vue&type=template&id=20372d22&scoped=true"
import script from "./CautionStream.vue?vue&type=script&lang=js"
export * from "./CautionStream.vue?vue&type=script&lang=js"

import "./CautionStream.vue?vue&type=style&index=0&id=20372d22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20372d22"]])

export default __exports__